
<div class="d-flex justify-content-between">

  <span class="disclaimerbottom" id="protocolo">
    Número do relatório: {{protocolo.numeroProtocolo}}  |  {{protocolo.dataGeracao | date:'longDate'}}  |  {{protocolo.dataGeracao | date:'shortTime'}}
</span>



<i  role="button" onclick="window.print()"  class="fa fa-print" style="color: #828588;" aria-hidden="true"></i>

</div>



